import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ]
})
export class ForgotComponent implements OnInit {
  public form: FormGroup;
  errors: any;
  success: any;
  constructor(private _authService: AuthService, private formBuilder: FormBuilder) { }
  ngOnInit() {
    window.FreshworksWidget('hide');

    this.form = this.formBuilder.group({
      email: ['', [Validators.required,Validators.email]],
    });
  }
  submit() {
    if(this.form.invalid){
      this.form.markAllAsTouched();
      return
    }
    this.success = null;
    this.errors = null;
    const params: any = {};
    params.email = this.form.get('email').value;
    this._authService.passwordChange(params, 'api/forgot/password')
      .subscribe((res: any) => {
        if (res.status_code == 200) {
          this.success = res.message

        } else {
          this.errors = res.message
        }

      }, (err: any) => {
        this.errors = 'something went wrong TryAgain!....'
      });
  }
}
